(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh-bogo-countdown"] && !Shopify.designMode) return;
  try {
    
  import('@theme/component').then(({ Component }) => {

  class BhBogoCountdown extends Component {
    connectedCallback() {
      super.connectedCallback();
      this.startClock();
      this.clockAbort?.abort();
      this.clockAbort = new AbortController();
      document.addEventListener('visibilitychange', () => this.updateClock(), { signal: this.clockAbort.signal });
      window.addEventListener('pageshow', () => this.updateClock(), { signal: this.clockAbort.signal });
    }

    updatedCallback() {
      super.updatedCallback();
      this.startClock();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      clearInterval(this.clockInterval);
      this.clockAbort?.abort();
    }

    startClock() {
      clearInterval(this.clockInterval);
      this.updateClock();
      this.clockInterval = setInterval(() => this.updateClock(), 1000);
    }

    updateClock() {
      const duration = (Math.max(1, Math.min(24, Number(this.dataset.cycleHours) || 7)) * 60
        + Math.max(0, Math.min(59, Number(this.dataset.cycleMinutes) || 0))) * 60 + 42;
      const now = Math.floor(Date.now() / 1000);
      if (!this.deadline || this.duration !== duration) {
        this.duration = duration;
        const key = 'bh-bogo-visitor-2026-10-v1-' + duration;
        let stored = 0;
        try { stored = Number(sessionStorage.getItem(key)); } catch {}
        this.deadline = Number.isFinite(stored) && stored > 0 && stored <= now + duration
          ? stored : now + duration;
        try { sessionStorage.setItem(key, String(this.deadline)); } catch {}
      }
      const remaining = Math.max(0, this.deadline - now);
      const values = {
        hours: Math.floor(remaining / 3600),
        minutes: Math.floor((remaining % 3600) / 60),
        seconds: remaining % 60
      };
      for (const [key, value] of Object.entries(values)) {
        const node = this.refs[key];
        const text = String(value).padStart(2, '0');
        if (node && node.textContent !== text) node.textContent = text;
      }
    }
  }

  if (!customElements.get('bh-bogo-countdown')) {
    customElements.define('bh-bogo-countdown', BhBogoCountdown);
  }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
